import { render, staticRenderFns } from "./tel-control.vue?vue&type=template&id=05440b1d&scoped=true&"
import script from "./tel-control.js?vue&type=script&lang=js&"
export * from "./tel-control.js?vue&type=script&lang=js&"
import style0 from "./tel-control.css?vue&type=style&index=0&id=05440b1d&scoped=true&lang=css&"
import style1 from "./tel-control-swiper.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05440b1d",
  null
  
)

export default component.exports